<template>
  <div class="flex justify-center items-center min-h-screen">
    <div class="w-11/12 max-w-7xl mx-auto mt-20 mb-16"> <!-- Increased width and max width -->
      <p class="mb-6 text-lg text-gray-700 leading-relaxed">
        LT Enviromonitoring is proudly led by a woman with extensive experience in the environmental management
        field. She has over 18 years of experience in the field. She started her professional job as an
        environmental intern at the Provincial Department of Environmental Affairs and was later appointed as an
        environmental officer and senior environmental officer. She worked in the public sector for 7 years,
        consulting for 5 years, and in the mining sector for 6 years. She is currently an independent
        environmental assessment practitioner registered with EAPASA and SACNASP serves mostly in Gauteng Province.
      </p>
      <div class="overflow-x-auto rounded-lg bg-white shadow-md p-6">
        <table class="min-w-full border-collapse border border-gray-300">
          <tbody class="bg-[#f6f8fa] divide-y divide-gray-200">
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-black">Impact Assessments conducted</td>
              <td class="border p-4 text-left text-gray-600">Project name</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">EIA Report and EMP</td>
              <td class="border p-4 text-left text-gray-600">Gaseloane demarcation of residential development</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">EIA Report and EMP</td>
              <td class="border p-4 text-left text-gray-600">Security village at Letabasdrift</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">EIA Report and EMP</td>
              <td class="border p-4 text-left text-gray-600">Fertilizer plant in Phalaborwa</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Basic Assessment Report</td>
              <td class="border p-4 text-left text-gray-600">Mokopane cemetery</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Basic Assessment Report</td>
              <td class="border p-4 text-left text-gray-600">Residential development in Polokwane</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">EIA Report</td>
              <td class="border p-4 text-left text-gray-600">Industrial development in Polokwane</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Basic assessment report</td>
              <td class="border p-4 text-left text-gray-600">Upgrading of gravel road from Mamaolo to Tooseng - Limpopo
              </td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Scoping, EIA Report and EMP</td>
              <td class="border p-4 text-left text-gray-600">Development of piggery and poultry in Dopeni- Limpopo</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Scoping, EIA Report and EMP</td>
              <td class="border p-4 text-left text-gray-600">Development of a filling station in Shayandima, Limpopo
              </td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Scoping, EIA Report and EMP</td>
              <td class="border p-4 text-left text-gray-600">Demarcation of residential ervens at Dresden – Limpopo</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">EMPr</td>
              <td class="border p-4 text-left text-gray-600">Developed an EMP for the entire Vhembe District
                Municipality, Limpopo</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Basic assessment report and EMP</td>
              <td class="border p-4 text-left text-gray-600">Road upgrade from Balmoral to Ogies – Mpumalanga</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Basic assessment report and EMP</td>
              <td class="border p-4 text-left text-gray-600">Development of a new school at Mamitwa, Limpopo</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Basic assessment report and EMP</td>
              <td class="border p-4 text-left text-gray-600">Bulk water Supply in Bushbuckridge, Limpopo</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Scoping, EIA Report and EMP</td>
              <td class="border p-4 text-left text-gray-600">Demarcation of 400 residential ervens in Ga-Lekgothoane,
                Limpopo</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Basic assessment report and EMP</td>
              <td class="border p-4 text-left text-gray-600">Armersfort bulk water supply, Mpumalanga</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">EMP</td>
              <td class="border p-4 text-left text-gray-600">Construction of VIP toilets, Mpumalanga</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Basic Assessment report and EMP</td>
              <td class="border p-4 text-left text-gray-600">Construction of 60km road from Litchetenburg to Deelpan,
                Northwest</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Environmental screening report and EMP</td>
              <td class="border p-4 text-left text-gray-600">Waterdal agricultural Holding, Sebokeng, Gauteng</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Basic assessment process (EA)</td>
              <td class="border p-4 text-left text-gray-600">Development of a ferrous and nonferrous metal foundry,
                Brakpan, Gauteng</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Section 24G application</td>
              <td class="border p-4 text-left text-gray-600">Development of a sheet metal business in Sebokeng, Gauteng
              </td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Ecological Impact Assessment</td>
              <td class="border p-4 text-left text-gray-600">Development of renewable energy projects, Western Cape</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Section 24G application</td>
              <td class="border p-4 text-left text-gray-600">Development of residential area, Zuurfontein,
                Vanderbiljpark, Gauteng</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Basic assessment process (EA)</td>
              <td class="border p-4 text-left text-gray-600">Development of a filling station on farm Alewynpoort,
                Gauteng</td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Scoping, EIA and EMPr</td>
              <td class="border p-4 text-left text-gray-600">Development of a township in Emfuleni Municipality, Gauteng
              </td>
            </tr>
            <tr class="hover:bg-gray-200 transition-colors duration-300">
              <td class="border p-4 text-left font-medium text-gray-700">Specialised report</td>
              <td class="border p-4 text-left text-gray-600">Development of a rehabilitation and implementation plan
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init();
export default {
  name: 'ServicesComponent',
};
</script>

<style>
/* Add any additional styles if necessary */
</style>